import React from 'react'
import IconBase from 'react-components/atoms/IconBase/IconBase'

function ChevronLeft({ className }) {
  return (
    <IconBase name="chevron-left" w={24} className={className}>
      <path
        d="M16.6201 2.99006C16.1301 2.50006 15.3401 2.50006 14.8501 2.99006L6.54006 11.3001C6.15006 11.6901 6.15006 12.3201 6.54006 12.7101L14.8501 21.0201C15.3401 21.5101 16.1301 21.5101 16.6201 21.0201C17.1101 20.5301 17.1101 19.7401 16.6201 19.2501L9.38006 12.0001L16.6301 4.75006C17.1101 4.27006 17.1101 3.47006 16.6201 2.99006Z"
        stroke="none"
      />
    </IconBase>
  )
}

export default ChevronLeft
